import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7fbaeda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = { class: "row-auto flex justify-between items-center mb-4" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "new-value" }, "Nouvelle Valeur", -1))
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "p-field flex justify-between mt-4" }
const _hoisted_10 = { class: "header-container" }
const _hoisted_11 = { class: "search-container search-container-right" }
const _hoisted_12 = { class: "p-input-icon-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center"} }, "Actions", -1))

import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import usePropertyService from '@/_services/propertyValue/propertyValue';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomPropertyValuesList',
  setup(__props) {

const openNew = () => {
  showDialog.value = true;
};
const validateInput = (data, field) => {
  if (data[field].length > 255) {
    if (!data.errors) {
      data.errors = {};
    }
    data.errors[field] = 'La valeur ne peut pas dépasser 255 caractères.';
  } else {
    if (data.errors) {
      delete data.errors[field];
    }
  }
};
const {
  page,
  defaultRowsPerPage,
  rowsPerPageOptions,
  rows,
  isLoading,
  tableData,
  currentPage,
  criteria,
  totalRecords,
  title,
  editingRows,
  showDialog,
  newValue,
  initProperty,
  populateDatatable,
  addVariantProductToPropertyValue,
  listVariantProductsOfPropertyValue,
  onPaginate,
  onFilterDt,
  onClearInputFilter,
  redirectToLastPage,
  onRowEditSave,
  addNewValue,
  errorMessage,
  cancelNewValue
} = usePropertyService();

onMounted(initProperty);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("button", {
      style: {"margin-bottom":"15px"},
      class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(redirectToLastPage)()))
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(title)), 1)
      ]),
      _createVNode(_unref(Dialog), {
        header: "Ajouter une nouvelle valeur",
        visible: _unref(showDialog),
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
        modal: true,
        closable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_FormKit, {
                type: "text",
                id: "new-value",
                modelValue: _unref(newValue),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(newValue) ? (newValue).value = $event : null)),
                validation: "length:0,100",
                "validation-messages": {
              length: 'Le nom de la propriété ne peut pas dépasser 100 caractères' 
              }
              }, null, 8, ["modelValue"]),
              (_unref(errorMessage))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Button), {
                label: "Ajouter",
                icon: "pi pi-check",
                class: "p-button-success mr-3",
                onClick: _unref(addNewValue)
              }, null, 8, ["onClick"]),
              _createVNode(_unref(Button), {
                label: "Annuler",
                icon: "pi pi-times",
                class: "p-button-warning",
                onClick: _unref(cancelNewValue)
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DataTable), {
        value: _unref(tableData),
        rows: _unref(rows),
        paginator: true,
        loading: _unref(isLoading),
        rowsPerPageOptions: _unref(rowsPerPageOptions),
        lazy: "",
        onPage: _unref(onPaginate),
        currentPage: _unref(currentPage),
        totalRecords: _unref(totalRecords),
        editMode: "row",
        dataKey: "uuid",
        editingRows: _unref(editingRows),
        "onUpdate:editingRows": _cache[4] || (_cache[4] = ($event: any) => (_isRef(editingRows) ? (editingRows).value = $event : null)),
        onRowEditSave: _unref(onRowEditSave),
        class: "p-datatable-custom"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _hoisted_13,
                _createVNode(_unref(InputText), {
                  modelValue: _unref(criteria),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(criteria) ? (criteria).value = $event : null)),
                  onKeyup: _withKeys(_unref(onFilterDt), ["enter"]),
                  onInput: _unref(onClearInputFilter),
                  placeholder: "Rechercher une valeur",
                  class: "w-full search-right"
                }, null, 8, ["modelValue", "onKeyup", "onInput"])
              ]),
              _createVNode(_unref(Button), {
                icon: "pi pi-plus",
                class: "btn-round-blue ml-4 mr-5",
                onClick: openNew
              })
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            headerStyle: "background-color: #F4F5F7; color: #111827; text-align: center;",
            field: "value",
            header: "Valeur de la propriété",
            style: {"width":"80%"}
          }, {
            editor: _withCtx(({ data, field }) => [
              _createVNode(_component_FormKit, {
                type: "text",
                id: field,
                name: field,
                modelValue: data[field],
                "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                onInput: value => data[field] = value,
                validation: "length:0,255",
                "validation-messages": {
              length: 'Le nom de la valeur de propriété ne peut pas dépasser 255 caractères',
            }
              }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            headerStyle: "background-color: #F4F5F7; color: #111827; text-align: center;",
            rowEditor: true,
            style: {"width":"3%","position":"relative"},
            bodyStyle: "text-align:right padding-right: 0.5em; right: -3rem;"
          }),
          _createVNode(_unref(Column), {
            headerStyle: "background-color: #F4F5F7; color: #111827; text-align: center;",
            bodyStyle: "text-align: center;"
          }, {
            header: _withCtx(() => [
              _hoisted_14
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Button), {
                size: "small",
                icon: "pi pi-pencil",
                class: _normalizeClass(["custom-button p-button-warning", `${slotProps.data.uuid}`]),
                style: {"margin-right":"0.5em"},
                title: "Éditer les produits associés",
                onClick: ($event: any) => (_unref(addVariantProductToPropertyValue)(slotProps.data.uuid))
              }, null, 8, ["class", "onClick"]),
              _createVNode(_unref(Button), {
                size: "small",
                icon: "pi pi-eye",
                class: _normalizeClass(["custom-button p-button-eye", `${slotProps.data.uuid}`]),
                style: {"margin-right":"0.5em"},
                title: "voir les produits associés",
                onClick: ($event: any) => (_unref(listVariantProductsOfPropertyValue)(slotProps.data.uuid))
              }, null, 8, ["class", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "rowsPerPageOptions", "onPage", "currentPage", "totalRecords", "editingRows", "onRowEditSave"])
    ])
  ], 64))
}
}

})